import { connectMenu } from '../../../../dist/vendor/instantsearch.js/es/connectors/index.js'
import { opts } from '../opts.js'
import { getDelegateTarget, parseTemplate, filterTitle } from '../util/helpers.js'
import { getUiState	} from '../util/state.js'
const { indexName, searchParam, facets } = opts.base;

export const facetSlugFromAttribute = attr =>
	facets.find(({ attribute }) => attribute === attr);

const cssClasses = {
	opened: 'algolia__facet--opened',
	toggle: 'algolia__facet-toggle',
	list: 'algolia__facet-filters',
	item: 'algolia__facet-filter',
	link: 'algolia__facet-filter-link',
	facet: 'algolia__facet',
	disabled: 'algolia__facet--disabled',
};
const { opened, disabled } = cssClasses

const dropdown = {
	open: container => container.classList.add(opened),
	close: container => container.classList.remove(opened),
	enable: container =>
		container.addEventListener('click', onFacetClick) &&
		container.classList.remove(disabled),
	disable: container =>
		container.classList.add(disabled) &&
		container.removeEventListener('click', onFacetClick),
	isDisabled: facet => facet.classList.contains(disabled),
	enableAll: () => {
		return facets.forEach(({ container }) =>
			this.enable(document.querySelector(container))
		)
	},
	isOpen: (container) => container.classList.contains(opened),
	setHeight: (container) => {
		const { bottom, height } = container.getBoundingClientRect()
		const { clientHeight } = document.documentElement

		if (!bottom || !height) return

		// make sure the dropdown doesn't go lower than the viewport
		container.style.maxHeight =
			bottom > clientHeight
				? `${height - (bottom - clientHeight) - 5}px`
				: container.style.maxHeight
	},
}

const onFacetClick = (event) => {
	const container = event.target.classList?.contains(cssClasses.facet)
		? event.target
		: getDelegateTarget(event, `.${cssClasses.facet}`)

	if (!container) {
		return
	}

	if (dropdown.isOpen(container)) {
		dropdown.close(container)
		return
	}
	dropdown.open(container) && dropdown.setHeight(container)
}


const postTypeSortOrder = [ 'page', 'mec-events', 'post', 'product']
const transformFacetFilters = ({ attribute }, items) => {

	console.log(attribute, items);

	const processedItems = items
		.map((filter) => ({
			...filter,
			...cssClasses,
			attribute,
			count: filter.count > 1 ? `(${filter.count})` : '',
		}));

	if ('post_type_label' === attribute) {
		processedItems.sort((a,b) => {
			return postTypeSortOrder.indexOf(a.label) - postTypeSortOrder.indexOf(b.label)
		})
	}

	return processedItems;

}

const beautify = slug  => {
	var words = slug.split('-');

	for (var i = 0; i < words.length; i++) {
	  var word = words[i];
	  words[i] = word.charAt(0).toUpperCase() + word.slice(1);
	}

	return words.join(' ');
}


const renderFacetFilters = ({ items, createURL }) => items.map((filter) => {
	const { menu } = getUiState();
	const stateValues = Object.values(menu);
	let checked = '';

	if (stateValues) {
		checked = [...stateValues].indexOf(filter.value) > -1 ? 'checked="checked"' : ''
	}

	return parseTemplate('filter', {
		...filter,
		checked,
		label: filter.attribute === 'post_type_label' ? filterTitle(filter.label) : beautify(filter.label),
		url: createURL(filter.value)
	});
}).join('');


const firstRender = ({ widgetParams: { container, cssClasses, label } }) => {
	container.innerHTML = parseTemplate('facets', {
		...cssClasses,
		label,
	})
	container.addEventListener('click', onFacetClick)
}

const renderFacet = (renderOptions, isFirstRender) => {
	const {
		items,
		refine,
		widgetParams: { cssClasses, container },
	} = renderOptions;

	isFirstRender && firstRender(renderOptions)

	if (!items.length) {
		container.disabled = 'disabled'
		container.classList.add(cssClasses.disabled)
	} else {
		delete container.disabled
		container.classList.remove(cssClasses.disabled)
	}

	// add filters
	const list = container.querySelector(`.${cssClasses.list}`);

	list.innerHTML = renderFacetFilters(renderOptions)

	list && [ ...list.children].map(el =>
		el.addEventListener('click', (e) => onFilterClick(e, refine))
	)
}

const onFilterClick = (event, refine) => {
	event.preventDefault();
	const filter = getDelegateTarget(event, `.${cssClasses.item}`);
	const facet = getDelegateTarget(event, `.${cssClasses.facet}`);
	const input = filter.querySelector('input');
	close(facet);
	refine(input.value);
}

const menu = connectMenu(renderFacet);

export const facetWidget = facet => ({
	params: {
		container: `.algolia__facet--${facet.slug}`,
		cssClasses,
		location: 'algolia__input-wrap',
		rootPath: '',
		showParentLevel: false,
		sortBy: ['isRefined'],
		showMore: false,
		transformItems(items) {

			return transformFacetFilters(facet, items)
		},
		...facet,
	},
	widget: menu,
})
